import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<LinkTo @route={{@route}} @models={{this.models}} @query={{this.query}} @disabled={{@disabled}} class={{@attrClassInternal}} ...attributes>\n  {{yield}}\n</LinkTo>", {
  moduleName: "ember-bootstrap/components/bs-link-to.hbs"
});